import HelperUtils from '@shared/utils/HelperUtils';
import React, {ReactElement, useState} from 'react';
import {useTranslation} from 'react-i18next';
import {addMessageToUser} from '@shared/services/MessageService';
import {useSelector} from 'react-redux';
import {SnackBarConfig} from 'src/utils/SnackBarConfig';
import {useSnackbar} from 'notistack';
import {UserModelMapper} from '@shared/services/service-mappers/ModelMapper';
import LinkDropdown from '@components/system/LinkDropDown/LinkDropdown';

interface MessagesAssignedUsersProps {
  messageDetails?: any;
  refreshConversation: any;
  groupUsers: Array<UserModelMapper>;
}
const MessagesAssignedUsers = (
  props: MessagesAssignedUsersProps
): ReactElement => {
  const {messageDetails, refreshConversation, groupUsers} = props;
  const {t} = useTranslation();
  const {enqueueSnackbar} = useSnackbar();
  const groupId = useSelector((state: any) => state.auth.groupId);
  const [usersList] = useState<Array<UserModelMapper>>(groupUsers || []);

  // API called for assigning to the user //
  const updateUserToMessage = async (
    clinicId: number,
    userId: number,
    selectedMessageId: number,
    user: any
  ) => {
    try {
      const updateResponse = await addMessageToUser(
        groupId,
        clinicId,
        userId,
        selectedMessageId
      );

      if (updateResponse && updateResponse?.message) {
        enqueueSnackbar(updateResponse?.message, SnackBarConfig('s'));
        // resetPagesInGrid();
        refreshConversation(selectedMessageId, messageDetails, user);
      }
    } catch (error: any) {
      enqueueSnackbar(error && error?.message, SnackBarConfig('e'));
    }
  };
  const renderAssignedUser = (row: any): ReactElement => {
    return (
      // Added enablePortal prop to make the custom popover to appear on top of body
      <LinkDropdown
        title={
          messageDetails?.assign_user_details
            ? t('INCOMING_SMS.CHANGE_TO')
            : t('INCOMING_SMS.ASSIGN_TO')
        }
        position="right-start"
        listItems={usersList.map(item => ({
          name: HelperUtils.formFullName(item.first_name, item.last_name),
          id: item.id
        }))}
        handleItemClick={(item: any) => {
          updateUserToMessage(
            row?.clinic_id,
            item?.id, // users_id
            row?.id, // message_id,
            item // selected assign user
          );
        }}
        enablePortal={true}
      />
    );
  };
  return <div>{renderAssignedUser(messageDetails)}</div>;
};

export default MessagesAssignedUsers;
